export default {
  label: {
    title: 'Add component?',
    description: 'Social network privacy rules and the Brazilian General Data Protection Law (LGPD) require that components containing authors\' information must not be accessible to guest users. Because your dashboard is shared, adding this component will hide it from those users.',
    button: {
      confirmButton: 'Add',
      cancelButton: 'Cancel',
    },
    message: {
      cancel: 'The component was not added to the dashboard.',
    },
  },
};
